import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// B2B sections (sync imports)
import HomeB2B from "./HomeB2B";
import IntroductionSection from "./IntroductionSection";
import LPnewsB2B from "./LPnewsB2B";
import RevealOnScroll from "../../../GlobalFunction/RevealOnScroll";
import Brands from "./Brands";
import CookieConsentModal from "../../../CookieConsentModal";

// Kept for possible future reuse.
// import AboutOverlaySection from "./AboutOverlaySection";

import AboutSection from "./AboutSection";

// ✅ NEW: scroll-following line background
import ScrollLineBackground from "./ScollLineBackground";

// language cookie helper
import { getLangFromCookie } from "../../../../Utils/LangCookie";
import ServiceProcess from "../../ProductInfo/b2b/ServiceProcess";

/* ---------- Localized text maps ---------- */

const fonts = {
  EN: "LINE Seed Sans",
  ZH: "LINE Seed TW",
  JP: "LINE Seed JP",
};

const ABOUT_TEXT = {
  ZH: {
    prefix: "台灣水禾的核心理念 ",
    highlight: "「潔淨初心  守護健康」",
    suffix: "",
    body: [
      "致力於為社會大眾、產業夥伴提供專業的",
      "衛生防護與清潔病媒防治方案",
      "積極推動創新、專業與永續的產品與服務",
    ],
  },

  EN: {
    prefix: "Taiwan SEHO's core belief is ",
    highlight: "“Cleanliness and Healthiness”",
    suffix: "",
    body: [
      "We are dedicated to providing the public and our industry partners",
      "reliable hygiene and pest-control solutions.",
      "Advancing Innovative, Professional, and Sustainable products.",
    ],
  },

  JP: {
    prefix: "台湾水禾は",
    highlight: "「潔浄の初心で健康を守る」",
    suffix: "",
    body: [
      "という理念を掲げ、社会や産業パートナーの皆さまに、",
      "衛生防護と害虫対策の専門的なソリューションをご提供いたします。",
      "また、革新性・専門性・",
      "持続可能性のある製品とサービスの推進に努めております。",
    ],
  },
};

export default function LandingPageB2B() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const prefersReducedMotion = useMediaQuery(
    "(prefers-reduced-motion: reduce)",
  );
  const footerRef = useRef(null);

  // ✅ hard reset scroll when entering LandingPage (prevents inherited scroll)
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  // language state synced with cookie + global event
  const [lang, setLang] = useState(() => getLangFromCookie() || "ZH");

  useEffect(() => {
    const syncLang = () => setLang(getLangFromCookie() || "ZH");
    syncLang();

    window.addEventListener("app:languageChanged", syncLang);
    return () => window.removeEventListener("app:languageChanged", syncLang);
  }, []);

  const about = ABOUT_TEXT[lang] || ABOUT_TEXT.ZH;

  // Simple animation helper (for the other sections)
  const anim = useMemo(
    () =>
      (variantDesktop, variantMobile, duration = 1200, delay = 0) => ({
        variant: prefersReducedMotion
          ? "none"
          : isMobile
            ? variantMobile
            : variantDesktop,
        duration: prefersReducedMotion ? 0 : duration,
        delay: prefersReducedMotion ? 0 : delay,
      }),
    [isMobile, prefersReducedMotion],
  );

  const titleColor = "#808080";

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "clip",
        position: "relative",
        bgcolor: "#fffffc", // ✅ page base background (instead of per-section)
      }}
    >
      {/* ✅ line is now ABOVE page background */}
      <ScrollLineBackground prefersReducedMotion={prefersReducedMotion} />

      {/* ✅ content stays above the line */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        <CookieConsentModal mode="b2b" policyHref="/b2b/privacy" />

        <HomeB2B bgcolor="transparent" lang={lang} fonts={fonts} />

        <IntroductionSection
          lang={lang}
          fonts={fonts}
          prefersReducedMotion={prefersReducedMotion}
        />

        <ServiceProcess
          boxRevealDirection="opposite"
        />

        {/*
        <AboutOverlaySection
          lang={lang}
          fonts={fonts}
          about={about}
          prefersReducedMotion={prefersReducedMotion}
        />
        */}

        <AboutSection
          lang={lang}
          fonts={fonts}
          about={about}
          prefersReducedMotion={prefersReducedMotion}
        />

      

        <Box
          sx={{
            position: "relative",
            zIndex: 7,

            /*
             * Old AboutOverlaySection compensation.
             *
             * Keep this here for reference in case the animated
             * AboutOverlaySection is enabled again.
             *
             * mt: {
             *   xs: "-28vh",
             *   sm: "-40vh",
             *   md: "-40vh",
             * },
             */

            mt: 0,

            width: "100%",
            maxWidth: 1280,
            mx: "auto",
            px: {
              xs: 2,
              md: 3,
            },
          }}
        >
          {/* ✅ IMPORTANT: make section transparent */}
          {/* <Service lang={lang} fonts={fonts} bg="transparent" /> */}
        </Box>

        <RevealOnScroll {...anim("slide-left", "fade-up", 900)}>
          <LPnewsB2B
            titleColor={titleColor}
            bgcolor="transparent"
            lang={lang}
            fonts={fonts}
          />
        </RevealOnScroll>
        <RevealOnScroll {...anim("slide-left", "fade-up", 900)}>
          <Brands
            titleColor={titleColor}
            bgcolor="transparent"
            lang={lang}
            border={true}
            fonts={fonts}
          />
        </RevealOnScroll>

        {/* <RevealOnScroll {...anim("slide-left", "fade-up", 900)}>
          <ButtonCardToB2C lang={lang} />
        </RevealOnScroll> */}

        <Box ref={footerRef} sx={{ height: { xs: 0, sm: "10svh" } }} />
      </Box>
    </Box>
  );
}
